import EnvService from '../app.env';

export const config = (env: EnvService) => ({
  issuer: `https://cognito-idp.eu-west-1.amazonaws.com/${env.value('AWS_USER_POOLS_ID')}`,
  clientId: env.value('AWS_USER_POOLS_WEB_CLIENT_ID'),
  redirectUri: env.value('AWS_AUTH_REDIRECT_SIGNIN'),
  responseType: 'code',
  scope: 'openid',
  showDebugInformation: true,
  strictDiscoveryDocumentValidation: false,
  requireHttps: true,
  sessionChecksEnabled: false,
  requestAccessToken: true,
  silentRefreshRedirectUri: env.value('AWS_AUTH_REDIRECT_SIGNIN'),
  useSilentRefresh: false,
});

export const providers = (env: EnvService) => env.value('AWS_AUTH_PROVIDERS')
  .split(',')
  .reduce((acc, value) => ({ ...acc, [value.trim().toUpperCase()]: value.trim() }), {} as { [key: string]: string });

export const authActivated = (env: EnvService) => env.value('PUBLIC_CLIENT_USE_AUTH') === 'true';
